import Http from "./Http";
import { apiSeguridad } from "../Utils/RutasApi";
import { trackPromise } from "react-promise-tracker";
import Autenticador from "./Autenticador";

async function obtenerUsuarioDelSistema() {
  const usuarioLocal = obtenerUsuario();
  const identificacionDelToken = Autenticador.ObtengaIdentificacion();

  if (usuarioLocal?.identificacion === identificacionDelToken) {
    return usuarioLocal;
  }

  const usuario = await trackPromise(
    Http.get(apiSeguridad.obtengaUsuarioDelSistema)

  );

  guardarUsuario(usuario.data);
  return obtenerUsuario();
}


function obtenerUsuario() {
  const usuario = localStorage.getItem("usuario") || "";
  let parsedUsuario = usuario ? JSON.parse(usuario) : null;
  return parsedUsuario;
}

function guardarUsuario(usuario: any) {
  localStorage.setItem("usuario", JSON.stringify(usuario));
}

function eliminarUsuario() {
  localStorage.removeItem("usuario");
}

function tieneRol(rol: string) {
  const usuario = obtenerUsuario();
  return usuario?.roles?.includes(rol);
}

function usaModulo(modulo: string) {
  const usuario = obtenerUsuario();
  const resultado = usuario?.roles?.filter((rol: string) =>
    rol.startsWith(modulo)
  );
  return resultado.length > 0;
}

const servicioUsuario = {
  obtenerUsuarioDelSistema,
  eliminarUsuario,
  tieneRol,
  usaModulo,
};

export default servicioUsuario;
